import React, { useRef, useEffect } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';

import './OpenConfirmDialog.css';
import useOutsideAlerter from '../../shared/hooks/useOutsideAlerter.js';
import isFilled from '../../shared/utilities/isFilled';

const OpenConfirmDialog = (props) => {
    const {openConfirm, setOpenConfirm, ticket, setBodyUptTicket, textoRes, adjuntoRes, user} = props
    const wrapperRef = useRef(null)
    const result = useOutsideAlerter(wrapperRef, openConfirm)

    useEffect(() => {
        result && setOpenConfirm(false)
    }, [result])

    const cancelCloseTicket = () => {
        setOpenConfirm(false)
    }

    const confirmCloseTicket = () => {
        setOpenConfirm(false)
        setBodyUptTicket(JSON.stringify({
            Ticket: {
                ...ticket, 
                estado: "CERRADO",
                mensaje: isFilled(textoRes) ? ticket.mensaje.concat({contenido: textoRes, usuarioId: user.idLogin}) : ticket.mensaje,
                adjunto: isFilled(adjuntoRes) ? ticket.adjunto.concat(adjuntoRes.map((adjunto) => ({nombreId: adjunto.nombreId, nombre: adjunto.nombre, size: adjunto.size, usuarioId: user.idLogin}))) : ticket.adjunto
            }
        }))
    }

    return (
        <div id="react-confirm-alert-overlay" style={{display:props.openConfirm ? '' : 'none'}}>
            <div className="react-confirm-alert-overlay">
                <div className="react-confirm-alert" ref={wrapperRef}>
                    <div className="react-confirm-alert-body">
                        <h1>ATENCIÓN: </h1>
                        <h2>Al cerrar el ticket ya no se podrá editar.</h2>
                        <hr size="8px" style={{marginBottom:"15px"}}/>
                        <p>No podrá responder más a este ticket.</p>
                    </div>
                    <div className="react-confirm-alert-button-group">
                        <button onClick={cancelCloseTicket}>Cancelar</button>
                        <button onClick={confirmCloseTicket}>Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OpenConfirmDialog;
